// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__nPKrq","author":"Table_author__1ycR2","authorImage":"Table_authorImage__AB9l_","unreadRow":"Table_unreadRow__LVOuq"};